import { TextField, InputAdornment } from '@mui/material'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { Controller } from 'react-hook-form'
import { NumericFormat } from 'react-number-format'

const FormInputPercentage = forwardRef(({ name, label, control, errors, disabled, ...props }, ref) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <NumericFormat
                    {...field}
                    ref={ref}
                    allowNegative={false}
                    decimalScale={0}
                    customInput={TextField}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                %
                            </InputAdornment>
                        ),
                    }}
                    isAllowed={(values) => {
                        if (!values.value) return true
                        const { floatValue } = values
                        return floatValue <= 100
                    }}

                    label={label}
                    error={!!errors}
                    disabled={disabled}
                    helperText={errors?.message}
                    onFocus={(event) => event.target.select()}
                    {...props}
                />
            )}
        />
    )
})

FormInputPercentage.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object,
    errors: PropTypes.object,
    disabled: PropTypes.bool
}


FormInputPercentage.displayName = 'FormInputPercentage'

export default FormInputPercentage